import { useQuery } from '@tanstack/react-query';
import { subcategoriesApi } from '../api/subcategories.api';
import { SubCategoryFilterParams } from '../types/subcategory.types';

export const useSubCategories = (params: SubCategoryFilterParams) => {
    return useQuery({
        queryKey: ['admin', 'subcategories', params],
        queryFn: () => subcategoriesApi.getPaged(params),
        placeholderData: (previousData) => previousData,
    });
};

export const useSubCategory = (id: string) => {
    return useQuery({
        queryKey: ['admin', 'subcategories', id],
        queryFn: () => subcategoriesApi.getById(id),
        enabled: !!id,
    });
};

export const useAllSubCategories = (categoryId?: string) => {
    return useQuery({
        queryKey: ['admin', 'subcategories', 'all', categoryId],
        queryFn: () => subcategoriesApi.getAll(categoryId),
    });
};
